import { render, staticRenderFns } from "./table-institute.vue?vue&type=template&id=1e38461b&scoped=true&"
import script from "./table-institute.vue?vue&type=script&lang=js&"
export * from "./table-institute.vue?vue&type=script&lang=js&"
import style0 from "./table-institute.vue?vue&type=style&index=0&id=1e38461b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e38461b",
  null
  
)

export default component.exports